import UsersActivity from 'components/Admin/UsersActivity/UsersActivity';

const UsersActivityListPage = () => {
	return <UsersActivity />;
};

export default UsersActivityListPage;
